'use strict';
var BASWebServices;
(function (BASWebServices) {
    var MessageBoxColorFilter = (function () {
        function MessageBoxColorFilter() {
        }
        MessageBoxColorFilter.Factory = function () {
            return function (input) {
                if (input.length == 0) {
                    return '';
                }
                var foundWarnings = false;
                var foundSuccess = false;
                for (var i = 0; i < input.length; i++) {
                    var currEntry = input[i];
                    if (currEntry.getIgnored()) {
                    }
                    else if (currEntry.getType().toLowerCase() === "error") {
                        return 'red-background';
                    }
                    else if ((currEntry.getType().toLowerCase() === "warning") ||
                        (currEntry.getType().toLowerCase() === "success (+warning)")) {
                        foundWarnings = true;
                    }
                    else if (currEntry.getType().toLowerCase() === "success") {
                        foundSuccess = true;
                    }
                }
                if (foundWarnings) {
                    return 'orange-background';
                }
                else if (foundSuccess) {
                    return 'green-background';
                }
                else {
                    return '';
                }
            };
        };
        return MessageBoxColorFilter;
    }());
    BASWebServices.MessageBoxColorFilter = MessageBoxColorFilter;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=MessageBoxColorFilter.js.map